import React, { FC, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { resetStatus, UnsubscribeTypes, userActions } from '@pharmaplan/common';
import LogoutHandler from '@pharmaplan/common/helpers/LogoutHandler';

import useUnsubscribeInvitationEmails from '../../hooks/UnsubscribeInvitationEmails/useUnsubscribeInvitationEmails';
import { showSuccess } from '../Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import { ReactComponent as CheckMailIcon } from '../../assets/svg/checkMailIcon.svg';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import LoginCustomCard from '../common/LoginCustomCard';
import { Constants } from '../../helpers/Constants';
import strings from '../../localization';

interface IUnsubscribeInvitationEmails {
  type: UnsubscribeTypes;
}

const UnsubscribeInvitationEmails: FC<IUnsubscribeInvitationEmails> = ({
  type = UnsubscribeTypes.professionalBookingInvitation,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { unsubscribe, success, textsArray } = useUnsubscribeInvitationEmails(type);

  const isUserLoggedIn = LogoutHandler.isUserLoggedIn();

  const navigateBack = () => {
    if (isUserLoggedIn) {
      navigate(-1);
    } else {
      navigate(Constants.paths.login);
    }
  };

  useEffect(() => {
    if (success) {
      showSuccess(dispatch, strings.unsubscribedSuccessfully);
      dispatch(resetStatus([userActions.professionalUnsubscribeInvitations]));
      navigateBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, isUserLoggedIn]);

  return (
    <LoginCustomCard
      icon={<CheckMailIcon />}
      textArray={textsArray}
      buttonTitle={strings.unsubscribe}
      onClick={unsubscribe}
    />
  );
};

export default UnsubscribeInvitationEmails;
